(function () {
  var KEY = 'fbtr-cookies';
  var box = document.getElementById('fbtr-cookies');
  if (!box) return;

  function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function save(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  function tell(on) {
    var consent = { analytics: on, marketing: on, preferences: on, sale_of_data: on };
    try {
      if (!window.Shopify || !Shopify.loadFeatures) return;
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
          Shopify.customerPrivacy.setTrackingConsent(consent, function () {});
        }
      });
    } catch (e) {}
  }

  box.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fbtr-cookies]');
    if (!b) return;
    var on = b.getAttribute('data-fbtr-cookies') === 'accept';
    save(on ? 'accepted' : 'declined');
    tell(on);
    box.classList.remove('is-in');
    setTimeout(function () { box.hidden = true; }, 250);
  });

  if (stored()) return;

  // wait until the country pop-up has been dealt with, so the two never stack
  var tries = 0;
  var timer = setInterval(function () {
    var country = document.getElementById('fbtr-country');
    if ((!country || country.hidden) || ++tries > 120) {
      clearInterval(timer);
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-in'); });
    }
  }, 600);
})();
